import React from "react";
import styled from "styled-components";

interface bt {
  title: string;
  bg: string;
  col: string;
  borCol: string;
}

const GlobalButton: React.FC<bt> = ({ title, bg, col, borCol }) => {
  return (
    <div>
      <Button bg={bg} col={col} borCol={borCol}>
        {title}
      </Button>
    </div>
  );
};

export default GlobalButton;

const Button = styled.span<{ bg: string; col: string; borCol: string }>`
  padding: 13px 25px;
  background-color: ${({ bg }) => bg};
  border-radius: 10px;
  margin: 0px 10px;
  border: 1.9px solid ${({ borCol }) => borCol};
  color: ${({ col }) => col};
  font-weight: 500;
  transition: all ease-in 0.3s;

  :hover {
    cursor: pointer;
    border: 2px solid ${({ borCol }) => borCol};
  }
`;

// #fbaf1b
